module.exports = __webpack_public_path__ + "static/img/twin-highway-1.fc0538e0.png";